<template>
  <modal name="EventPopup" width="500px" height="auto" :clickToClose="false" v-show="!IS_MOBILE">
    <img :src="require('../../assets/img/main/main_pop.jpg')" />

    <div class="btn_area">
      <button @click="btnClose()" class="popup_close">닫기</button>
      <button @click="btnTodayClose()" class="popup_TodayClose">오늘 하루 그만보기</button>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["text"],
  data: () => ({
    message: "EventPopup.vue",
    eventPopupView: false, // 이벤트 표시 여부
    popupId: "1", // event page 추가할 경우 증가해야 함
    todayVal: new Date().yyyymmdd()
  }),
  methods: {
    btnTodayClose() {
      console.log("btnTodayClose");
      localStorage.setItem("popupId", this.popupId);
      localStorage.setItem("todayVal", this.todayVal);
      this.$modal.hide("EventPopup");
    },
    btnClose() {
      console.log("btnClose");
      this.$modal.hide("EventPopup");
    }
  },
  computed: {},
  destroyed() {},
  mounted() {
    // 이벤트 표시 여부
    if (this.eventPopupView == false) {
      return;
    }

    // id 값과 날짜 값이 같지 않으면 팝업 표시
    if (
      this.popupId != localStorage.getItem("popupId") ||
      this.todayVal != localStorage.getItem("todayVal")
    ) {
      this.$modal.show("EventPopup");
    }
  },
  computed: {
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    }
  },
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style>
/*
.v--modal-overlay {
  background: rgba(0, 0, 0, 0.4);
}
.v--modal {
  background: none;
  box-shadow: none;
}


.btn_area {
  position: relative;
  height: 30px;
  display: block;
  margin-top: 10px;
}

.popup_close {
  color: #ffffff;
  position: absolute;
  border: 0;
  right: 0;
  font-size: 0;
}
.popup_close::before {
  content: "";
  display: inline-block;
  background: url("../../assets/img/cancel_w.svg");
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  vertical-align: middle;
}
.popup_TodayClose {
  color: #ffffff;
  position: absolute;
  border: 0;
  left: 0;
  font-size: 1.5em;
}
.popup_TodayClose::before {
  content: "";
  display: inline-block;
  background: url("../../assets/img/done_w.svg");
  background-size: 100% 100%;
  width: 30px;
  height: 30px;
  vertical-align: middle;
  margin-right: 5px;
}
*/
</style>



// WEBPACK FOOTER //
// src/components/layout/EventPopup.vue